
import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  cabeceraColor,
  grayColor,
  blackColor,
  whiteColor
} from './style'

export const colors = {
  primaryColor: primaryColor,
  warningColor: warningColor,
  dangerColor: dangerColor,
  successColor: successColor,
  infoColor: infoColor,
  roseColor: roseColor,
  cabeceraColor: cabeceraColor,
  grayColor: grayColor,
  blackColor: blackColor,
  whiteColor: whiteColor
}
